// extracted by mini-css-extract-plugin
module.exports = {"container":"matchDetails__container___9_1HW","date":"matchDetails__date___2jBjx","icon":"matchDetails__icon___20xHw","team":"matchDetails__team___3Pjta"};